import { FC } from "react";

export const Logout: FC = () => {

  const handleLogout = () => {
    const teamName = import.meta.env.VITE_CF_ACCESS_TEAM_NAME;
    
    if (!teamName) {
      console.warn("VITE_CF_ACCESS_TEAM_NAME is not set. Using fallback alert.");
      alert("環境設定（VITE_CF_ACCESS_TEAM_NAME）が不足しているため、ログアウトURLを生成できません。");
      return;
    }

    // Cloudflare Accessのログアウトエンドポイントへリダイレクト
    window.location.href = `https://${teamName}.cloudflareaccess.com/cdn-cgi/access/logout`;
  };

  return (
    <div className="">
      <button
        onClick={handleLogout}
        className="w-full py-2 px-4 bg-red-600 hover:bg-red-700 rounded text-white transition-colors flex items-center justify-center gap-2"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
        </svg>
        ログアウト
      </button>
    </div>
  );
};
